import _slicedToArray from "/home/pavle/Documents/development/edu-campaign/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
export function useButtonType(value) {
  var _React$useState = React.useState(!value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isButton = _React$useState2[0],
      setIsButton = _React$useState2[1];

  var refCallback = React.useCallback(function (node) {
    if (!node) return;
    setIsButton(node.tagName === "BUTTON");
  }, []);
  var type = isButton ? "button" : undefined;
  return {
    ref: refCallback,
    type: type
  };
}